@if (businessTransaction) {
  <app-tabs>
    <app-tab [title]="'meteringpoint.businesstransaction.show.details' | translate">
      <app-value-details
        [collection]="showBusinesstransactionMasterdata"
        [data]="businessTransaction"
      ></app-value-details>
    </app-tab>
    <app-tab [title]="'meteringpoint.businesstransaction.show.message' | translate">
        @if (businessTransaction.rsmText) {
          <pre class="text-sm font-normal max-w-full text-wrap" [textContent]="businessTransaction.rsmText"></pre>
        }
    </app-tab>
  </app-tabs>
}
